import { ContentTypeEnumForBackend, ContentModalContentType, ContentTypeForComparison } from 'domains/content/types';
import { URLPaths } from 'models/enums';
import { isRootFolder } from 'utils/folders';
import { ContentStatus } from './ContentStatusText';

const getBasePathByContentType = (contentType: ContentTypeForComparison): string => {
    switch (contentType) {
        case ContentTypeForComparison.EMAIL:
            return URLPaths.CONTENT_CREATE_EMAIL;
        case ContentTypeForComparison.LANDING_PAGE:
            return URLPaths.CONTENT_CREATE_PAGE;
        case ContentTypeForComparison.SMS:
            return URLPaths.CONTENT_CREATE_SMS;
        case ContentTypeForComparison.DIRECT_MAIL:
            return URLPaths.CONTENT_CREATE_DIRECT_MAIL;
        case ContentTypeForComparison.VOICE:
            return URLPaths.CONTENT_CREATE_VOICE_CALL;
        case ContentTypeForComparison.WHATSAPP:
            return URLPaths.CONTENT_CREATE_WHATSAPP;
        default:
            return URLPaths.CONTENT;
    }
};

const getViewBasePathByContentType = (contentType: ContentTypeForComparison): string => {
    switch (contentType) {
        case ContentTypeForComparison.EMAIL:
            return URLPaths.CONTENT_VIEW_EMAIL;

        case ContentTypeForComparison.SMS:
            return URLPaths.CONTENT_VIEW_SMS;
        case ContentTypeForComparison.DIRECT_MAIL:
            return URLPaths.CONTENT_VIEW_DIRECT_MAIL;
        case ContentTypeForComparison.VOICE:
            return URLPaths.CONTENT_VIEW_VOICE_CALL;
        case ContentTypeForComparison.WHATSAPP:
            return URLPaths.CONTENT_VIEW_WHATSAPP;
        default:
            return URLPaths.CONTENT_VIEW_SCREEN;
    }
};

export const getContentCreatePath = ({
    contentType,
    id,
    isCopy,
    parentFolderId,
    status,
}: {
    contentType: ContentTypeForComparison;
    id?: number;
    isCopy?: boolean;
    parentFolderId?: number;
    status?: ContentStatus;
}) => {
    const basePath = getBasePathByContentType(contentType);

    const isVoiceCall = contentType === ContentTypeForComparison.VOICE;

    const queryParams: Record<string, string> = {};

    if (!isVoiceCall) {
        queryParams.id = id?.toString() ?? 'default';
    } else if (id) {
        queryParams.id = id.toString();
    }

    if (isCopy) {
        queryParams.isCopy = 'true';
    }

    if (parentFolderId && !isRootFolder(parentFolderId)) {
        queryParams.parentFolderId = parentFolderId.toString();
    }
    if (status) {
        queryParams.status = status;
    }

    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${basePath}?${queryString}` : basePath;
};

export const getContentViewPath = ({
    contentType,
    id,
    parentFolderId,
    status,
}: {
    contentType: ContentTypeForComparison;
    id: number;
    parentFolderId?: number;
    status?: ContentStatus;
}) => {
    const basePath = getViewBasePathByContentType(contentType);

    const queryParams: Record<string, string> = {};

    queryParams.id = id.toString();

    if (parentFolderId && !isRootFolder(parentFolderId)) {
        queryParams.parentFolderId = parentFolderId.toString();
    }
    if (status) {
        queryParams.status = status;
    }

    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${basePath}?${queryString}` : basePath;
};

export const getContentType = (content?: ContentModalContentType) => {
    if (content?.type === 'voice') {
        return 'Voice Call';
    }
    if (content?.type === 'SMS') {
        return 'Text Message';
    }
    return content?.type;
};
export function contentTypeToSnakeCase(type: keyof typeof ContentTypeEnumForBackend): string {
    return ContentTypeEnumForBackend[type] || '';
}
